import React from 'react'
import s from './ApplicationsList.module.scss'

const ApplicationsList = ({ isEmpty = false, emptyText = 'No applications', children }) => {
	return (
		<section className={s.list}>
			{isEmpty ? <div className={s.empty}>{emptyText}</div> : children}
		</section>
	)
}

export default ApplicationsList
